import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';

const { get, post, put, remove } = erpApi();
const BASE_URL = `${urlBackend}api/v1/gestion-tickets/`;

export type DocRol = 'GENERAL' | 'USUARIO' | 'ADMIN';

export interface DocSeccion {
  id_documentacion?: string;
  rol: DocRol | string;
  /** Módulo del manual: TICKETS | VISITAS | TRASLADOS (las secciones viejas no lo traen). */
  modulo?: string;
  orden: number;
  codigo: string;
  titulo: string;
  icono?: string;
  contenido: string;
  activo?: boolean;
}

// Lectura: cualquier usuario autenticado (secciones activas).
export const getDocumentacion = async () =>
  get<DocSeccion[]>(`${BASE_URL}documentacion/`, true);

// Lectura admin: incluye inactivas (para el editor).
export const getDocumentacionAdmin = async () =>
  get<DocSeccion[]>(`${BASE_URL}documentacion/admin/`, true);

export const createDocumentacion = async (data: DocSeccion) =>
  post<DocSeccion>(`${BASE_URL}documentacion/`, data, true);

export const updateDocumentacion = async ({ id, data }: { id: string; data: Partial<DocSeccion> }) =>
  put<DocSeccion>(`${BASE_URL}documentacion/${id}/`, data, true);

export const deleteDocumentacion = async (id: string) =>
  remove<null>(`${BASE_URL}documentacion/${id}/`, true);

export const useFetchDocumentacion = () =>
  useQuery({
    queryKey: ['documentacion'],
    queryFn: getDocumentacion,
    staleTime: 60_000,
  });

export const useFetchDocumentacionAdmin = (enabled: boolean) =>
  useQuery({
    queryKey: ['documentacion', 'admin'],
    queryFn: getDocumentacionAdmin,
    enabled,
    staleTime: 10_000,
  });

export const useMutateDocumentacion = () => {
  const qc = useQueryClient();
  const invalidate = () => {
    qc.invalidateQueries({ queryKey: ['documentacion'] });
  };
  const create = useMutation({ mutationFn: createDocumentacion, onSuccess: invalidate });
  const update = useMutation({ mutationFn: updateDocumentacion, onSuccess: invalidate });
  const del = useMutation({ mutationFn: deleteDocumentacion, onSuccess: invalidate });
  return { create, update, del };
};
